'use strict';

angular.module('membership')
  .controller('ContactsSearchCtrl', [
    '$scope', 'contactsSearchViewModel',
    function ($scope, viewModel) {
      $scope.model = new viewModel();
    }
  ]);
